/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAuthorFeed.defs.js'
export * as $defs from './getAuthorFeed.defs.js'
